import AboutMe from "./AboutMe";
import Skills from "./Skills";
import './ab.css'

export default function AboutMain(){
    return(
        <>
        <div className="bg-gradient-to-r from-[#F8CE89] to-[#578CA3]">
            <AboutMe/>
            <Skills/>
        </div>
        </>
    )
}